import { render, staticRenderFns } from "./SocialNetworkMain.vue?vue&type=template&id=c36ab192"
import script from "./SocialNetworkMain.vue?vue&type=script&lang=js"
export * from "./SocialNetworkMain.vue?vue&type=script&lang=js"
import style0 from "./SocialNetworkMain.vue?vue&type=style&index=0&id=c36ab192&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports